export interface HrPerformanceDashboard {
  owningCompanyId?: number;
  cycles?: number;
  activeCycles?: number;
  goals?: number;
  openGoals?: number;
  reviews?: number;
  submittedReviews?: number;
  openDevelopmentPlans?: number;
  recentCycles?: HrPerformanceCycle[];
  pendingReviews?: HrPerformanceReview[];
}

export interface HrPerformanceCycle {
  performanceCycleId?: number;
  owningCompanyId?: number;
  cycleCode?: string;
  cycleName?: string;
  periodStart?: string;
  periodEnd?: string;
  reviewStart?: string;
  reviewEnd?: string;
  cycleStatus?: string;
  calibrationStatus?: string;
  workerCategory?: string;
  notes?: string;
}

export interface HrPerformanceGoal {
  performanceGoalId?: number;
  owningCompanyId?: number;
  performanceCycleId?: number;
  cycleName?: string;
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  goalCode?: string;
  goalTitle?: string;
  goalDescription?: string;
  goalCategory?: string;
  weight?: number;
  targetValue?: number;
  actualValue?: number;
  measurementUnit?: string;
  goalStatus?: string;
  dueDate?: string;
  managerEmployeeId?: number;
  managerName?: string;
  notes?: string;
}

export interface HrPerformanceReview {
  performanceReviewId?: number;
  owningCompanyId?: number;
  performanceCycleId?: number;
  cycleName?: string;
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  reviewerEmployeeId?: number;
  reviewerName?: string;
  managerEmployeeId?: number;
  managerName?: string;
  reviewType?: string;
  reviewStatus?: string;
  overallRating?: number;
  overallRatingLabel?: string;
  selfSummary?: string;
  managerSummary?: string;
  calibrationRating?: number;
  calibrationStatus?: string;
  submittedAt?: string;
  approvedAt?: string;
  notes?: string;
  sections?: HrPerformanceReviewSection[];
  ratings?: HrPerformanceReviewRating[];
}

export interface HrPerformanceReviewSection {
  performanceReviewSectionId?: number;
  owningCompanyId?: number;
  performanceReviewId?: number;
  sectionCode?: string;
  sectionName?: string;
  sectionType?: string;
  weight?: number;
  score?: number;
  comments?: string;
  sortOrder?: number;
}

export interface HrPerformanceReviewRating {
  performanceReviewRatingId?: number;
  owningCompanyId?: number;
  performanceReviewId?: number;
  performanceGoalId?: number;
  goalTitle?: string;
  ratingType?: string;
  ratingValue?: number;
  ratingLabel?: string;
  comments?: string;
}

export interface HrDevelopmentPlan {
  developmentPlanId?: number;
  owningCompanyId?: number;
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  performanceReviewId?: number;
  planTitle?: string;
  planDescription?: string;
  targetSkillId?: number;
  targetCourseId?: number;
  ownerEmployeeId?: number;
  ownerName?: string;
  planStatus?: string;
  startDate?: string;
  targetDate?: string;
  completedDate?: string;
  notes?: string;
}

export interface HrPerformanceKpiContext {
  employeeId?: number;
  employeeName?: string;
  employeeNumber?: string;
  attendanceEvents?: number;
  safetyIncidents?: number;
  podDocumentQualityIssues?: number;
  onTimeDeliveryParticipation?: number;
  complaintInvolvement?: number;
  trainingCompletions?: number;
  overdueTrainingItems?: number;
  workforceCashSettlementDelays?: number;
  contextNotes?: string;
}

export const HR_PERFORMANCE_CYCLE_STATUSES = ['DRAFT', 'ACTIVE', 'CLOSED'];

export const HR_PERFORMANCE_GOAL_STATUSES = ['DRAFT', 'OPEN', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'];

export const HR_PERFORMANCE_REVIEW_STATUSES = ['DRAFT', 'IN_PROGRESS', 'SUBMITTED', 'APPROVED'];

export const HR_PERFORMANCE_REVIEW_TYPES = ['SELF', 'MANAGER'];

export const HR_PERFORMANCE_CALIBRATION_STATUSES = ['NOT_STARTED', 'NOT_CALIBRATED', 'CALIBRATED', 'FINALIZED'];

export const HR_DEVELOPMENT_PLAN_STATUSES = ['OPEN', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'];
